<div class="row d-flex image-item m-2 p-3">
  <div class="row image-row" *ngFor="let image of imageList">
    <div class="col-1">
      <fa-icon
        class="clickable-icon"
        size="2x"
        [icon]="imageIcon"
        aria-label="image icon"
        [ngbPopover]="imagePreview"
        popoverTitle="Vista previa"
        (dblclick)="showOverlay(image, $event)"></fa-icon>
      <ng-template #imagePreview>
        <img
          [src]="getImageBase64Url(image)"
          alt="Preview"
          class="img-fluid"
          style="max-width: 200px" />
      </ng-template>
    </div>
    <div class="col-8">
      <div class="row">
        {{ image.nombreImagen }}
      </div>
      <div class="row">
        <div class="col-1">
          <mat-icon class="clickable-icon" (click)="onDeleteImage(image)"
            >delete</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
</div>

<!-- overlay and ng-templates -->
<div class="image-overlay" *ngIf="overlayImageUrl" (click)="hideOverlay()">
  <img [src]="overlayImageUrl" alt="Overlay Image" class="img-fluid" />
</div>
